module.exports = __webpack_public_path__ + "53ca595c90a802097d1fb10c91cf0c7b.svg";